export default "__VITE_ASSET__DgcfEXnr__"